import { css } from 'styled-components';
import { getPx } from '../../helpers/common';
import { isDefined } from '../../helpers/defined';
import { styleArrayForBreakpoints, styleForBreakpoints } from '../../helpers/media-style';
export const alignStyle = css`
  ${({
  $lineHeight,
  $multiline,
  $vertical = false
}) => $multiline && isDefined($lineHeight) ? styleArrayForBreakpoints([$lineHeight, $vertical], ([$height, $vertical]) => !$vertical && $multiline ? `height: ${getPx($height)};` : '') : ''}
  ${({
  $multiline,
  $vertical = false
}) => $multiline ? styleForBreakpoints($vertical, $vertical => !$vertical && $multiline ? `align-self: flex-start;` : '') : ''}
`;